<div *ngIf="visible" class="legend-wrapper">
  <p>{{classificationProperty}}</p>
  <div *ngFor="let value of getClassValues()" class="entry">
    <div class="color" [style.backgroundColor]="getColorStyleByKey(value)"></div>
    <div class="value">{{value}}</div>
  </div>
</div>
